import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { useNavigate } from 'react-router-dom';
import { AnyAction } from '@reduxjs/toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import icon_mainhub from '../assets/MainHub_White.svg';
import icon_team from '../assets/The_Team_White.svg';
import DonutChart, { ChartData } from './donutchart';

const LinkedCaseListExpand = (item: Cases.caseListState) => {
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const actionOnRow = (item: Cases.caseListState) => {
		dispatch(Cases.selectCase(item.caseno));
	}

	const openLinkedCase = (e: React.MouseEvent<HTMLElement>, item: Cases.caseListState) => {
		e.stopPropagation();
		if (cases.linkedcase.caseno === item.caseno) {
			navigate('/linkedcase');
			return;
		}
		const setcaseno = () => new Promise((resolve) => resolve(dispatch((Cases.setCaseNo(item)) as unknown as AnyAction)));
		dispatch(Cases.setOpeningLinkedCase(true));
		setcaseno().then(() => dispatch(Cases.getLinkedCase(({ caseno: item.caseno, type: item.casetype, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			let action;
			try {
				action = JSON.parse(result.payload as string);
			} catch (e) {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
			if (action.status === 'OK') {
				navigate('/linkedcase');
				return;
			} else {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
		}));
	}

	const openLinkedTeam = (e: React.MouseEvent<HTMLElement>, item: Cases.caseListState) => {
		e.stopPropagation();
		if (cases.linkedcase.caseno === item.caseno) {
			navigate('/linkedteam');
			return;
		}
		const setcaseno = () => new Promise((resolve) => resolve(dispatch((Cases.setCaseNo(item)) as unknown as AnyAction)));
		dispatch(Cases.setOpeningLinkedTeam(true));
		setcaseno().then(() => dispatch(Cases.getLinkedCase(({ caseno: item.caseno, type: item.casetype, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			let action;
			try {
				action = JSON.parse(result.payload as string);
			} catch (e) {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
			if (action.status === 'OK') {
				navigate('/linkedteam');
				return;
			} else {
				dispatch(UI.setError({ visible: true, message: result.payload }));
				return;
			}
		}));
	}

	return (
		<div className="CaseExpand" style={{ overflow: 'hidden', height: (item.selected ? 52 : 0) }}>
			<div className="row100" style={{ justifyContent: 'start', alignItems: 'end' }} key={item.caseno} onClick={() => actionOnRow(item)}>
				<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={(e) => openLinkedCase(e, item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_mainhub} alt='MainHub-Icon' />
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Open Case</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isOpeningLinkedCase &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
				<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={(e) => openLinkedTeam(e, item)}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_team} alt='Team-Icon' />
						<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
					</div>
					<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						{cases.isOpeningLinkedTeam &&
							<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
						}
					</div>
				</div>
			</div>
			{item.linked.length > 0 &&
				<div style={{ padding: '4px 0' }}>
					<div style={{ fontFamily: 'OpenSans-Bold' }}>Linked Cases:</div>
					{(item.linked || []).map((item: Cases.caseListState) => (
						<div className="hoverDark" key={item.caseno} style={{ padding: 0, color: 'black', fontSize: 13 }} onClick={(e) => openLinkedCase(e, item)}>
							<div style={{ alignItems: 'center' }} className="row100">
								<div className="flexGrow1" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.caseno}</div>
								<div className="flexGrow1" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.type}</div>
								<div className="flexGrow1" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.opened}</div>
								<div className="flexGrow2" style={{ padding: '0 4px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>{item.description}</div>
								<div className="flexGrow2" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.site}</div>
								<div className="flexGrow3" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.address}</div>
								<div className="flexGrow1" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
									<DonutChart data={ChartData(item)} size={36} />
								</div>
							</div>
						</div>
					))}
				</div>
			}
		</div>
	);
}

export default LinkedCaseListExpand;